import React from 'react';
import { Box, Button, ITheme, SvgIcon, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as fileIcon } from '../../../assets/file.svg'
import { LeoDocumentsPath, LeoDocumentsPathExample } from '../../../resources/api-constants';

export interface IPortfolioDocumentationStepItemProps {
    title: string;
    description?: string;
    url: string;
}

const PortfolioDocumentationStepItem: React.FC<IPortfolioDocumentationStepItemProps> = ({ title, description }) => {
    const theme = useTheme() as ITheme;
    const { t } = useTranslation();

    
    const onDownload = () => {
        window.open(LeoDocumentsPath + '/' + LeoDocumentsPathExample);
    }

    return <Box display="flex" flexDirection={"column"} alignItems={"flex-start"} width={"240px"} borderRadius={"8px"} bgcolor={theme.palette.background.paper} sx={{ boxShadow: "0px 2px 16px 0px #0000000F" }} gap={"32px"} padding={"25px 23px"}>
        <Box display="flex" flexDirection={"column"} gap={"12px"}>
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"700"} color={theme.palette.primary.dark}>{title}</Typography>
            <Typography fontSize={"12px"} lineHeight={"14.63px"} fontWeight={"500"}>{description}</Typography>
        </Box>
        <SvgIcon component={fileIcon} inheritViewBox style={{ width: "100%", height: "75px", color: theme.palette.primary.main }} />
        <Button variant='outlined' sx={{ width: "100%", textTransform: "none", padding: "10px 0" }} onClick={onDownload}>{t('CreatePortfolioButtonDownloadPDF')}</Button>
    </Box>;
}

export default PortfolioDocumentationStepItem;